(function () {
    'use strict';

    angular
        .module('app')
        .directive('fgTree', fgTree);

    fgTree.$inject = ['$window', '$timeout'];

    function fgTree($window, $timeout) {
        // Usage:
        //     <fgTree></fgTree>
        // Creates:
        // 
        var directive = {
            restrict: "E",
            replace: true,
            link: link,
            scope: {
                collection: '=',
                onClicked: '=',
                onExpanded: '=?',
                processing: '=?',
                expanded: '=?',
                maxItems: '=?',
                onShowMoreItems: '=?',
                showmoreLabel: '=?',
                root: '='
            },
            template: "<div class='tree-list'>" +
            "<fg-node showmore-label='showmoreLabel' ng-if='member.uniqueId <= maxItems' ng-repeat='member in collection track by member.uniqueId' member='member' on-expanded='itemExpanded' on-clicked='itemClicked'>" +
            "</fg-node>" +
            "<span ng-if='maxItems < collection.length && root' ng-click='onShowMoreItems();' class='show-more'> {{showmoreLabel}} {{maxItems}} / {{collection.length}}</span>"
        };
        return directive;

        function link(scope, element, attrs) {
            scope.maxItems = 250;
            scope.itemCoolDown = false;
            scope.onShowMoreItems = function () {
                scope.maxItems = scope.maxItems + 100;
                if (scope.maxItems >= scope.collection.length) {
                    $(element).parent().find('.show-more').remove();
                }
            }

            scope.itemClicked = function (item, doubleClick) {
                if (!scope.itemCoolDown) {
                    if (scope.onClicked) {
                        scope.itemCoolDown = true;
                        scope.onClicked(item, doubleClick);
                        
                    }
                }
                //avoids double calls.
                $timeout(function () {
                    scope.itemCoolDown = false;
                }, 100);
            }
            scope.itemExpanded = function (item) {
                if (scope.onExpanded) {
                    return scope.onExpanded(item);
                }
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('fgNode', fgNode);

    fgNode.$inject = ['$compile', '$timeout'];

    function fgNode($compile, $timeout) {
        // Usage:
        //     <fgNode></fgNode>
        // Creates:
        // 
        return {
            restrict: "E",
            replace: true,
            scope: {
                member: '=',
                onClicked: '=',
                onExpanded: '=',
                onShowMore: '=',
                showmoreLabel: '=',
            },
            template: '<div class="tree-node"><i ng-show="(member.children.length>0 || member.isParent) ' +
                '&& !member.expanded" ng-click="expand()" class="fa fa-plus-square-o" aria-hidden="true"></i> ' +
                '<i class="fa fa-minus-square-o" ng-show="member.expanded && (member.children.length>0 || member.isParent)" ng-click="collapse()"></i> ' +
                '<span class="node-spacer" ng-hide="member.isParent"></span>' +
                "<div id='node{{member.uniqueId}}' ng-class=\"{ 'selected': member.selected } \" ng-dblclick=\"itemClicked(member, true)\" ng-click=\"itemClicked(member)\" class=\"node-item\">" +
                '<img src="{{::member.icon}}"/>' +
                '  {{::member.name}}</div><div class="spinner" ng-show="member.loading"><i class="fa fa-spinner fa-spin"></i></div></div>',
            link: function (scope, element, attrs) {

                scope.maxItems = 250;

                scope.increaseMaxItems = function () {

                    scope.maxItems = scope.maxItems + scope.maxItems;
                    scope.onShowMore();
                    if (scope.maxItems <= scope.member.children.length) {
                        angular.element(element[0].getElementsByClassName('show-more')).remove();
                    }
                }

                scope.itemClicked = function (item, doubleClick) {
                    scope.onClicked(item, doubleClick);
                }

                scope.itemExpanded = function (item) {
                    return scope.onExpanded(item);
                }

                if (scope.member.expanded && angular.isArray(scope.member.children)) {
                    element.append("<fg-tree showmore-label='showmoreLabel' max-items='maxItems' collection='member.children' on-clicked='itemClicked' on-expanded='itemExpanded' on-show-more-items='increaseMaxItems'></fg-tree>");
                    element.append("<span ng-if='maxItems < member.children.length' ng-click='increaseMaxItems(); maxItems = maxItems + 100' class='show-more'>" + scope.showmoreLabel + " {{maxItems}} / {{member.children.length}}</span>");
                    childScope = scope.$new();
                    $compile(element.contents())(childScope);
                }

                var childScope;
                scope.expand = function () {
                    var showChildren = function () {
                        scope.member.expanded = true;
                        element.append("<fg-tree showmore-label='showmoreLabel' collection='member.children' on-clicked='itemClicked' on-expanded='itemExpanded' on-show-more-items='increaseMaxItems'></fg-tree>");
                        element.append("<span ng-if='maxItems < member.children.length' ng-click='increaseMaxItems(); maxItems = maxItems + 100' class='show-more'>" + scope.showmoreLabel + " {{maxItems}} / {{member.children.length}}</span>");
                        childScope = scope.$new();
                        $compile(element.contents())(childScope);
                        var content = document.getElementsByClassName('lp-content');
                    }

                    if (scope.onExpanded) {
                        showChildren();
                        var children = scope.member.children ? scope.member.children : [];

                        // Don't keep going if this node is infinite.
                        //if (children.length == 0) {
                        if (scope.member.isInfinite != true && children.length == 0) {
                            scope.member.loading = true;
                            var expanded = scope.onExpanded(scope.member).then(function (tree) {
                                $timeout(function () {
                                    scope.member.loading = false;
                                });
                                scope.member.children = tree.children;
                            });
                        }
                    }
                    else {
                        showChildren();
                    }



                }
                scope.collapse = function () {

                    scope.member.expanded = false;
                    var cleanUp = function (children) {
                        angular.forEach(children, function (item, key) {
                            item.expanded = false;
                            if (angular.isArray(item.children)) {
                                cleanUp(item.children);
                            }
                        })
                    }

                    angular.element(element[0].getElementsByClassName('tree-node')).remove();
                    angular.element(element[0].getElementsByClassName('show-more')).remove();
                    cleanUp(scope.member.children);
                    childScope.$destroy();
                }

            }
        }
    }

})();